module.exports = __webpack_public_path__ + "static/media/ZHT0062-2.cf352562.png";